import React, { useState } from "react";
import { toast } from "react-toastify";
import API_BASE_URL from "../../API/ConfigAPI";
import "./changePasswordModal.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function ChangePasswordModal({
  currentPassword,
  newPassword,
  confirmPassword,
  setCurrentPassword,
  setNewPassword,
  setConfirmPassword,
  setShowModal,
}) {
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [errors, setErrors] = useState({ old: "", new: "", confirm: "" });

  const handlePasswordChange = async () => {
    const newErrors = { old: "", new: "", confirm: "" };

    if (!currentPassword) newErrors.old = "Veuillez renseigner l'ancien mot de passe.";
    if (!newPassword) newErrors.new = "Veuillez renseigner le nouveau mot de passe.";
    if (!confirmPassword) newErrors.confirm = "Veuillez confirmer le nouveau mot de passe.";
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      newErrors.confirm = "Les nouveaux mots de passe ne correspondent pas.";
    }

    const validate = (password) => {
      const rules = [];
      if (!/.{10,}/.test(password)) rules.push("- 10 caractères");
      if (!/[a-z]/.test(password)) rules.push("- une lettre minuscule");
      if (!/[A-Z]/.test(password)) rules.push("- une lettre majuscule");
      if (!/[@#$%^&*\-_=;:,.!?]/.test(password)) rules.push("- un caractère spécial : @#$%^&*-_+=;:,.!?");
      return rules;
    };

    const passwordRules = validate(newPassword);
    if (passwordRules.length > 0) {
      newErrors.new = "Le mot de passe doit contenir au moins :\n" + passwordRules.join("\n");
    }

    if (newErrors.old || newErrors.new || newErrors.confirm) {
      setErrors(newErrors);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/change-password/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({
          old_password: currentPassword,
          new_password: newPassword,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success("Mot de passe mis à jour avec succès !");
        setShowModal(false);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setErrors({ old: "", new: "", confirm: "" });
      } else if (data?.message === "Ancien mot de passe incorrect.") {
        setErrors((prev) => ({ ...prev, old: "L'ancien mot de passe est incorrect." }));
      } else {
        toast.error(data.message || "Erreur lors du changement de mot de passe.");
      }
    } catch (err) {
      console.error(err);
      toast.error("Erreur réseau.");
    }
  };

  return (
    <div className="overlay" onClick={() => setShowModal(false)}>
      <div className="modal-password" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content1">
          <h3>Changer le mot de passe</h3>

          <div className="input-group">
            <label>Ancien mot de passe :</label>
            <div className="password-wrapper">
              <input
                type={showCurrent ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />
              <span className="eye-icon" onClick={() => setShowCurrent(!showCurrent)}>
                {showCurrent ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.old && <p className="error-text">{errors.old}</p>}
          </div>

          <div className="input-group">
            <label>Nouveau mot de passe :</label>
            <div className="password-wrapper">
              <input
                type={showNew ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <span className="eye-icon" onClick={() => setShowNew(!showNew)}>
                {showNew ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            <div className="password-rules">
              <p className={/.{10,}/.test(newPassword) ? "rule valid" : "rule invalid"}>- 10 caractères</p>
              <p className={/[a-z]/.test(newPassword) ? "rule valid" : "rule invalid"}>- Une lettre minuscule</p>
              <p className={/[A-Z]/.test(newPassword) ? "rule valid" : "rule invalid"}>- Une lettre majuscule</p>
              <p className={/[@#$%^&*\-_=;:,.!?]/.test(newPassword) ? "rule valid" : "rule invalid"}>
                - Un caractère spécial : @#$%^&*-_+=;:,.!?
              </p>
            </div>
            {errors.new && <p className="error-text">{errors.new}</p>}
          </div>

          <div className="input-group">
            <label>Confirmer le nouveau mot de passe :</label>
            <div className="password-wrapper">
              <input
                type={showConfirm ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <span className="eye-icon" onClick={() => setShowConfirm(!showConfirm)}>
                {showConfirm ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
            {errors.confirm && <p className="error-text">{errors.confirm}</p>}
          </div>

          <div className="modal-actions">
            <button className="cancel-button" onClick={() => setShowModal(false)}>Annuler</button>
            <button className="submit-button" onClick={handlePasswordChange}>Valider</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordModal;
